import styled from 'styled-components';
import {Text4} from "../../../../../../../libs/uiKit/globalStyledComponents";

export const StyledDeclarationInfoText = styled(Text4)`
  margin: 3rem;
  color: #cccccc;
  font-size: 1.8rem;
`;